/**
 * Translations object containing messages for different languages
 * @type {Object.<string, Object.<string, string>>}
 */
const translations = {
  en: {
    "Error sending request": "Error sending request",
    "Error": "Error",
    "Your progress": "Your progress",
    "Up to": "Up to",
    "From": "From",
    "Failed to load verification. Please refresh the page and try again.": "Failed to load verification. Please refresh the page and try again.",
    "Internal error occurred. Please try again.": "Internal error occurred. Please try again.",
    "Verification timed out. Please complete it again.": "Verification timed out. Please complete it again.",
    "Verification error. Please refresh the page or try again.": "Verification error. Please refresh the page or try again.",
    "Processing...": "Processing...",
    "Login error. Please try again.": "Login error. Please try again.",
    "Network error occurred. Please try again later.": "Network error occurred. Please try again later.",
    "Redirecting...": "Redirecting...",
    // Tournament-specific translations
    "coming soon": "coming soon",
    "ago": "ago",
    "from now": "from now",
    "Error loading tournaments. Please try again.": "Error loading tournaments. Please try again.",
    "There are no matches for selected filters": "There are no matches for selected filters",
    "Unable to apply filters. Please try again.": "Unable to apply filters. Please try again.",
    "Next Game": "Next Game",
    "Loading tournaments...": "Loading tournaments...",
    "Applying filters...": "Applying filters...",
    "Loading more tournaments...": "Loading more tournaments...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Football",
    "Basketball": "Basketball",
    "Hockey": "Hockey",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Other games",
    "Please select at least one item": "Please select at least one item",
    "In": "In",
    "Out": "Out",
    // Add more English translations here
  },
  ru: {
    "Error sending request": "Ошибка отправки запроса",
    "Error": "Ошибка",
    "Your progress": "Ваш прогресс",
    "Up to": "До",
    "From": "От",
    "Failed to load verification. Please refresh the page and try again.": "Не удалось загрузить проверку. Обновите страницу и попробуйте снова.",
    "Internal error occurred. Please try again.": "Произошла внутренняя ошибка. Пожалуйста, попробуйте снова.",
    "Verification timed out. Please complete it again.": "Время проверки истекло. Пожалуйста, пройдите ее снова.",
    "Verification error. Please refresh the page or try again.": "Ошибка при проверке. Попробуйте обновить страницу или повторить попытку.",
    "Processing...": "Обработка...",
    "Login error. Please try again.": "Ошибка входа. Попробуйте снова.",
    "Network error occurred. Please try again later.": "Произошла ошибка сети. Пожалуйста, попробуйте позже.",
    "Redirecting...": "Перенаправление...",
    // Tournament-specific translations
    "coming soon": "скоро начало",
    "ago": "идет",
    "from now": "до начала",
    "Error loading tournaments. Please try again.": "Ошибка загрузки турниров. Попробуйте еще раз.",
    "There are no matches for selected filters": "Нет матчей для выбранных фильтров",
    "Unable to apply filters. Please try again.": "Не удалось применить фильтры. Попробуйте еще раз.",
    "Next Game": "Следующая игра",
    "Loading tournaments...": "Загрузка турниров...",
    "Applying filters...": "Применение фильтров...",
    "Loading more tournaments...": "Загрузка дополнительных турниров...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Футбол",
    "Basketball": "Баскетбол",
    "Hockey": "Хоккей",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Другие игры",
    "Please select at least one item": "Пожалуйста, выберите хотя бы один предмет",
    "In": "Внесено",
    "Out": "Получено",
    // Add more Russian translations here
  },
  uk: {
    "Error sending request": "Помилка надсилання запиту",
    "Error": "Помилка",
    "Your progress": "Ваш прогрес",
    "Up to": "До",
    "From": "Від",
    "Failed to load verification. Please refresh the page and try again.": "Не вдалося завантажити перевірку. Оновіть сторінку і спробуйте ще раз.",
    "Internal error occurred. Please try again.": "Виникла внутрішня помилка. Будь ласка, спробуйте ще раз.",
    "Verification timed out. Please complete it again.": "Час перевірки минув. Будь ласка, пройдіть її ще раз.",
    "Verification error. Please refresh the page or try again.": "Помилка перевірки. Оновіть сторінку або спробуйте ще раз.",
    "Processing...": "Обробка...",
    "Login error. Please try again.": "Помилка входу. Спробуйте ще раз.",
    "Network error occurred. Please try again later.": "Виникла помилка мережі. Будь ласка, спробуйте пізніше.",
    "Redirecting...": "Перенаправлення...",
    // Tournament-specific translations
    "coming soon": "скоро початок",
    "ago": "триває",
    "from now": "до початку",
    "Error loading tournaments. Please try again.": "Помилка завантаження турнірів. Спробуйте ще раз.",
    "There are no matches for selected filters": "Немає матчів для вибраних фільтрів",
    "Unable to apply filters. Please try again.": "Не вдалося застосувати фільтри. Спробуйте ще раз.",
    "Next Game": "Наступна гра",
    "Loading tournaments...": "Завантаження турнірів...",
    "Applying filters...": "Застосування фільтрів...",
    "Loading more tournaments...": "Завантаження додаткових турнірів...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Футбол",
    "Basketball": "Баскетбол",
    "Hockey": "Хокей",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Інші ігри",
    "Please select at least one item": "Будь ласка, виберіть хоча б один предмет",
    "In": "Внесено",
    "Out": "Отримано",
    // Add more Ukrainian translations here
  },
  es: {
    "Error sending request": "Error al enviar la solicitud",
    "Error": "Error",
    "Your progress": "Tu progreso",
    "Up to": "Hasta",
    "From": "Desde",
    "Failed to load verification. Please refresh the page and try again.": "No se pudo cargar la verificación. Actualiza la página e inténtalo de nuevo.",
    "Internal error occurred. Please try again.": "Ocurrió un error interno. Por favor, inténtalo de nuevo.",
    "Verification timed out. Please complete it again.": "El tiempo de verificación ha expirado. Por favor, complétala de nuevo.",
    "Verification error. Please refresh the page or try again.": "Error de verificación. Actualiza la página o inténtalo de nuevo.",
    "Processing...": "Procesando...",
    "Login error. Please try again.": "Error de inicio de sesión. Inténtalo de nuevo.",
    "Network error occurred. Please try again later.": "Ocurrió un error de red. Por favor, inténtalo más tarde.",
    "Redirecting...": "Redirigiendo...",
    // Tournament-specific translations
    "coming soon": "próximamente",
    "ago": "hace",
    "from now": "a partir de ahora",
    "Error loading tournaments. Please try again.": "Error al cargar torneos. Inténtalo de nuevo.",
    "There are no matches for selected filters": "No hay partidos para los filtros seleccionados",
    "Unable to apply filters. Please try again.": "No se pudieron aplicar los filtros. Inténtalo de nuevo.",
    "Next Game": "Próximo Juego",
    "Loading tournaments...": "Cargando torneos...",
    "Applying filters...": "Aplicando filtros...",
    "Loading more tournaments...": "Cargando más torneos...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Fútbol",
    "Basketball": "Baloncesto",
    "Hockey": "Hockey",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Otros juegos",
    "Please select at least one item": "Por favor, seleccione al menos un elemento",
    "In": "Contribuido",
    "Out": "Recibió",
    // Add more Spanish translations here
  },
};

/**
 * Get the current language from the html's lang attribute
 * @returns {string} The current language code (ISO 639-1)
 */
export function getCurrentLanguage() {
  const fullLocale = document.documentElement.lang || 'en';
  return fullLocale.split('-')[0].toLowerCase();
}

/**
 * Translate a message to the current language
 * @param {string} message - The message to translate
 * @returns {string} The translated message or the original message if no translation is found
 */
export function translate(message) {
  const lang = getCurrentLanguage();
  
  if (!Object.prototype.hasOwnProperty.call(translations, lang)) {
    console.warn(`Translation not available for language: ${lang}`);
    return translations['en'][message] || message;
  }
  
  return translations[lang][message] || translations['en'][message] || message;
}

/**
 * Set the current language
 * @param {string} lang - The ISO 639-1 language code (e.g., 'en', 'es')
 * @throws {Error} If the provided language code is invalid
 */
export function setLanguage(lang) {
  if (typeof lang !== 'string' || !/^[a-z]{2}$/.test(lang)) {
    throw new Error('Invalid language code. Please use ISO 639-1 format (e.g., en, es)');
  }
  document.documentElement.lang = lang;
}